import { render } from "./wantbuyList.vue?vue&type=template&id=32dd5d47&scoped=true&ts=true"
import script from "./wantbuyList.vue?vue&type=script&lang=ts"
export * from "./wantbuyList.vue?vue&type=script&lang=ts"

import "./wantbuyList.vue?vue&type=style&index=0&id=32dd5d47&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32dd5d47"]])

export default __exports__